import React, { forwardRef } from "react";

import { masks } from "../../../utils/masks";

import { Input } from "./styles";

export const InputArea = forwardRef((props, ref) => {
  const { variant, mask, hide, keyboard, hasError, watch } = props;

  function onChange(event) {
    if (mask) event.target.value = masks[mask](event.target.value);
    if (watch) watch(event.target.value);
  }

  return (
    <Input
      {...props}
      className="focus:touch-pan-x"
      ref={ref}
      type={hide ? "password" : keyboard === "numeric" ? "tel" : "text"}
      hasError={hasError}
      variant={variant}
      placeholder=""
      onChange={onChange}
      autoComplete="new-password"
    />
  );
});
